import { useTranslation } from "react-i18next";
import useMembersList from "../../../../../../hooks/useMembersList";
import TableLoader from "../../../../../../library/table-loader";
import {
  ButtonWrapper,
  Container,
  ContentWrapper,
  TextWrapper,
  UpperContainer,
  UpperTextWrapper,
} from "./styled";
import ListView from "./list-view";
import { useEffect, useState } from "react";
import { useAuth } from "../../../../../../AuthContext";
import { Title } from "../../../../../../library/title";
import { Text } from "../../../../../../library/text";
import Button from "../../../../../../library/button";
import Modal from "../../../../../../library/modal";
import InviteModalContent from "./invite-modal";

const AccessView = () => {
  const { t } = useTranslation();
  const { loading } = useMembersList();
  const { currentUser } = useAuth();
  const { fetchMembersList } = useMembersList();
  const [inviteModalOpen, setInviteModalOpen] = useState<boolean>(false);

  const openInviteModal = () => {
    setInviteModalOpen(true);
  };

  const closeInvitationModal = () => {
    setInviteModalOpen(false);
  };

  useEffect(() => {
    if (currentUser?.selectedWorkspace?.id && currentUser?.uid) {
      fetchMembersList();
    }
  }, [fetchMembersList, currentUser?.uid, currentUser?.selectedWorkspace?.id]);

  return (
    <Container>
      <UpperContainer>
        <UpperTextWrapper>
          <TextWrapper>
            <Title size="sm">Alle tilganger</Title>
            <Text size="small" color="dark">
              En oversikt over alle brukere som har tilgang til arbeidsmiljøet
              ditt.
            </Text>
          </TextWrapper>
          <ButtonWrapper>
            <Button
              onClick={openInviteModal}
              icon="plus"
              variant="regular"
              color="blue"
            >
              Legg til ny
            </Button>
          </ButtonWrapper>
        </UpperTextWrapper>
      </UpperContainer>
      <ContentWrapper>
        {loading ? (
          <TableLoader
            message={
              t(
                "dashboard.pages.workspace.bottom-view.loading-view.message"
              ) as string
            }
          />
        ) : (
          <ListView />
        )}
      </ContentWrapper>
      <Modal
        open={inviteModalOpen}
        onClose={closeInvitationModal}
        title={t("dashboard.pages.workspace.invite-modal.title")}
      >
        <InviteModalContent onClose={closeInvitationModal} />
      </Modal>
    </Container>
  );
};

export default AccessView;
